const locale = {
	users_list_title: 'Users',
	admins_list_title: 'Dashboard',
	dashboard_admin_title: 'Dashboard - Admin',
	search_admin: 'Search admin',
	search_user: 'Search user',
	search_project:'Search project',
	map_member: 'Map Member',
	view_project:'View Project',
	cancel: 'Cancel',
	delete:'Remove',
	deactivate:'Deactivate',
	submit:'Submit',
	remove:'Remove',
	edit_details: 'Edit Details',
	change_password: 'Change Password',
	deactivate_account: 'Deactivate Account',
	resend_welcome_email: 'Re-activate',
	new_password: 'New Password',
	enter_new_password: 'Enter new password',
	confirm_password:'Confirm Password',
	enter_confirm_password:'Enter confirm password',
	update_password: 'Update Password',
	recover_account: 'Recover Account',
	activate_account:'Activate Account',
	companies: 'Companies',
	dashboard:'Dashboard',
	member_type: 'Member Type',
	group_type: 'Group Type',
	affiliation: 'Affiliation',
	account_status: 'Account Status',
	reset_filters: 'Reset Filter',
	filter_by: 'Filter By :',
	export:'Export',
};

export default locale;
